import React, { useState } from "react"
import data from '../data/data.json'

const TABS = [
  ["interviews", "Interviews", ""],
  ["lectures", "Lectures", ""],
  ["democracy", "Democracy", " Essays"],
  ["covid", "COVID", " Essays"],
  ["podcasts", "Podcasts", ""],
]

const INTERVIEW_PREVIEW = 6

export default function Media() {
  const [tab, setTab] = useState("interviews")
  const [showAllInterviews, setShowAllInterviews] = useState(false)

  const interviews = data.media.interviews || []
  const lectures = data.media.lectures || []
  const democracyEssays = (data.media.essays && data.media.essays.democracy) || []
  const covidEssays = (data.media.essays && data.media.essays.covid) || []
  const podcasts = data.media.podcasts || []

  const isVideo = tab === "interviews" || tab === "lectures"
  const allVideoData = tab === "interviews" ? interviews : lectures
  const videoData = tab === "interviews" && !showAllInterviews
    ? allVideoData.slice(0, INTERVIEW_PREVIEW)
    : allVideoData
  const essayData = tab === "democracy" ? democracyEssays : tab === "covid" ? covidEssays : podcasts

  return (
    <section style={wrap} id="media" className="media-wrap">
      <h2 style={titleStyle}>In the Media</h2>
      <div style={tabs} className="media-tabs">
        {TABS.map(([key, label, suffix]) => (
          <button
            key={key}
            style={{ ...tabBtn, ...(tab === key ? tabActive : {}) }}
            onClick={() => setTab(key)}
            className="media-tab-btn"
          >
            {label}{suffix && <span className="tab-suffix">{suffix}</span>}
          </button>
        ))}
      </div>

      {isVideo && (
        <>
          <div style={videoGrid} className="media-video-grid">
            {videoData.map((v, i) => (
              <div key={i} style={videoCard} className="media-video-card">
                <div style={videoThumb}>
                  <iframe
                    src={v.link}
                    allowFullScreen
                    loading="lazy"
                    title={v.title}
                    style={iframe}
                  />
                </div>
                <p style={videoTitle} className="media-video-title" title={v.title}>{v.title}</p>
                {v.date && <p style={videoDate}>{v.date}</p>}
              </div>
            ))}
          </div>
          {tab === "interviews" && interviews.length > INTERVIEW_PREVIEW && (
            <button style={showMoreBtn} onClick={() => setShowAllInterviews(v => !v)}>
              {showAllInterviews ? "Show fewer ↑" : `Show all ${interviews.length} interviews ↓`}
            </button>
          )}
        </>
      )}

      {!isVideo && (
        <div style={essayList}>
          {essayData.map((e, i) => (
            <div key={i} style={essayItem}>
              <div>
                <p style={essayTitle}>{e.title}</p>
                <p style={essayMeta}>{e.publication} · {e.date}</p>
              </div>
              <a href={e.link} target="_blank" rel="noreferrer" style={essayLink}>
                {tab === "podcasts" ? "Listen →" : "Read →"}
              </a>
            </div>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 900px) {
          .media-video-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 600px) {
          .media-video-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 16px !important; }
          .media-video-title {
            font-size: 13px !important;
            line-height: 1.35 !important;
            padding: 10px 12px !important;
            display: -webkit-box !important;
            -webkit-line-clamp: 2 !important;
            -webkit-box-orient: vertical !important;
            overflow: hidden !important;
          }
          .media-essay-item { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 480px) {
          .media-wrap { padding-left: 20px !important; padding-right: 20px !important; }
        }
        @media (max-width: 600px) {
          .media-tabs { gap: 0 !important; justify-content: space-between !important; }
          .media-tab-btn { padding: 10px 6px !important; font-size: 9px !important; letter-spacing: 0.08em !important; white-space: nowrap !important; }
          .media-tab-btn .tab-suffix { display: none !important; }
        }
      `}</style>
    </section>
  )
}

const wrap = {
  padding: "96px 40px",
  maxWidth: "1320px",
  margin: "0 auto",
}

const titleStyle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 300,
  fontSize: "32px",
  letterSpacing: "0.04em",
  color: "var(--cobalt)",
  marginBottom: "48px",
}

const tabs = {
  display: "flex",
  gap: 0,
  marginBottom: "48px",
  borderBottom: "2px solid var(--cream-mid)",
  flexWrap: "wrap",
}

const tabBtn = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "11px",
  letterSpacing: "0.16em",
  textTransform: "uppercase",
  color: "var(--ink-soft)",
  padding: "12px 24px",
  cursor: "pointer",
  border: "none",
  background: "none",
  borderBottom: "2px solid transparent",
  marginBottom: "-2px",
  transition: "all 0.2s",
}

const tabActive = {
  color: "var(--coral)",
  borderBottomColor: "var(--coral)",
}

const videoGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "24px",
}

const videoCard = {
  background: "white",
  overflow: "hidden",
}

const videoThumb = {
  position: "relative",
  paddingBottom: "56.25%",
  height: 0,
  overflow: "hidden",
  background: "var(--cobalt-light)",
}

const iframe = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  border: "none",
}

const videoTitle = {
  fontSize: "15px",
  lineHeight: 1.4,
  color: "var(--ink)",
  padding: "14px 16px",
  marginBottom: 0,
}

const videoDate = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "10px",
  letterSpacing: "0.1em",
  color: "var(--ink-soft)",
  padding: "0 16px 14px",
  marginBottom: 0,
}

const showMoreBtn = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "11px",
  letterSpacing: "0.16em",
  textTransform: "uppercase",
  color: "var(--cobalt)",
  border: "none",
  background: "none",
  cursor: "pointer",
  marginTop: "32px",
  padding: "14px 0",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  borderBottom: "1px solid var(--cobalt)",
}

const essayList = {
  display: "flex",
  flexDirection: "column",
  gap: 0,
}

const essayItem = {
  padding: "20px 0",
  borderBottom: "1px solid var(--cream-mid)",
  display: "grid",
  gridTemplateColumns: "1fr auto",
  gap: "20px",
  alignItems: "center",
}

const essayTitle = {
  fontSize: "17px",
  lineHeight: 1.45,
  color: "var(--ink)",
  marginBottom: "3px",
}

const essayMeta = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "11px",
  letterSpacing: "0.08em",
  color: "var(--ink-soft)",
  marginBottom: 0,
}

const essayLink = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "9px",
  letterSpacing: "0.14em",
  textTransform: "uppercase",
  color: "var(--coral)",
  border: "1px solid var(--coral)",
  padding: "5px 12px",
  textDecoration: "none",
  whiteSpace: "nowrap",
  display: "inline-block",
}
